import React from 'react';
import LocationTemplate from './LocationTemplate';

const YoungsvillePage: React.FC = () => {
  return (
    <LocationTemplate
      cityName="Youngsville"
      stateName="North Carolina"
      countyName="Franklin"
      zipCodes={["27596"]}
      latitude={36.0254}
      longitude={-78.4747}
      population={1445}
      historicalFact="Incorporated in 1905, growing community in Franklin County."
      nearbyTowns={[
        "Wake Forest, NC",
        "Franklinton, NC",
        "Louisburg, NC",
        "Bunn, NC",
        "Rolesville, NC",
        "Henderson, NC",
        "Creedmoor, NC",
        "Raleigh, NC"
      ]}
    />
  );
};

export default YoungsvillePage;